import React from "react";

export const defaultDiversityGroupRows = [
  {
    category: "Executive Management",
    groupA: "",
    groupB: "",
    groupC: "",
    notDisclosed: "",
  },
  {
    category: "Non-Executive Management",
    groupA: "",
    groupB: "",
    groupC: "",
    notDisclosed: "",
  },
  {
    category: "Technical Employees",
    groupA: "",
    groupB: "",
    groupC: "",
    notDisclosed: "",
  },
  {
    category: "All Other Employees",
    groupA: "",
    groupB: "",
    groupC: "",
    notDisclosed: "",
  },
];

const DiversityGroupTable = ({
  diversityGroupTable,
  setDiversityGroupTable,
}) => {
  // Render fallback to defaults; only write to state on change
  const safeTableData =
    Array.isArray(diversityGroupTable) && diversityGroupTable.length
      ? diversityGroupTable
      : defaultDiversityGroupRows;

  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...safeTableData]; // clone current rows (saved or defaults)
    updated[rowIndex][field] = value;
    setDiversityGroupTable(updated); // push up to parent/Redux
  };

  return (
    <div
      style={{
        marginTop: "16px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "100%",
        maxWidth: "none",
        marginInline: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "16px",
              }}
            >
              Category
            </th>
            <th style={tableHeaderStyle}>Group A (%)</th>
            <th style={tableHeaderStyle}>Group B (%)</th>
            <th style={tableHeaderStyle}>Group C (%)</th>
            <th style={tableHeaderStyle}>Not disclosed (%)</th>
          </tr>
        </thead>

        <tbody>
          {safeTableData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "600",
                  paddingLeft: "16px",
                  backgroundColor: "#D3C9CE",
                  whiteSpace: "normal",
                }}
              >
                {row.category}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.groupA}
                  onChange={(e) =>
                    handleInputChange(index, "groupA", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.groupB}
                  onChange={(e) =>
                    handleInputChange(index, "groupB", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.groupC}
                  onChange={(e) =>
                    handleInputChange(index, "groupC", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  min="0"
                  max="100"
                  placeholder="%"
                  value={row.notDisclosed}
                  onChange={(e) =>
                    handleInputChange(index, "notDisclosed", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "20px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const inputStyle = {
  width: "95%",
  padding: "14px",
  height: "40px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default DiversityGroupTable;
